// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DepositModal.css */

/* Fondo semitransparente */
.modal-backdrop {
    background-color: rgba(0, 0, 0, 0.6) !important;
  }

  /* Contenedor del modal */
  .modal-content {
    border-radius: 0.5rem;
    box-shadow: var(--sn-sombra);
    overflow: hidden;
  }

  /* Header */
  .modal-header {
    background-color: var(--sn-superficie-2);
    border-bottom: 1px solid var(--sn-borde);
  }
  .modal-header .modal-title {
    font-weight: 600;
    color: var(--sn-texto);
  }

  /* Body */
  .modal-body {
    padding: 1.5rem;
    background-color: var(--sn-superficie);
  }

  /* Tablas dentro del modal */
  .modal-body .table {
    margin-bottom: 1.5rem;
  }
  .modal-body .table th,
  .modal-body .table td {
    vertical-align: middle;
  }

  /* Alertas */
  .alert {
    border-radius: 0.375rem;
    font-size: 0.95rem;
  }
  .alert-success {
    background-color: var(--sn-exito-suave);
    border-color: var(--sn-exito);
    color: var(--sn-exito-texto);
  }
  .alert-danger {
    background-color: var(--sn-peligro-suave);
    border-color: var(--sn-peligro);
    color: var(--sn-peligro-texto);
  }

  /* Inputs y botones superiores */
  .modal-body input[type="file"] {
    padding: 0.375rem 0.75rem;
  }
  .modal-body .btn {
    font-size: 0.9rem;
  }

  /* Spinner centrar texto */
  .spinner-border {
    width: 2rem;
    height: 2rem;
  }

  /* Imágenes PDF y previews */
  .modal-body embed,
  .modal-body img {
    border: 1px solid var(--sn-borde);
    border-radius: 0.25rem;
  }

  /* Footer */
  .modal-footer {
    background-color: var(--sn-superficie-2);
    border-top: 1px solid var(--sn-borde);
  }

  /* Botón de WhatsApp personalizado en grafito */
  .btn-whatsapp {
    background-color: var(--sn-texto) !important;    /* fondo grafito */
    border-color: var(--sn-texto) !important;
    color: var(--sn-texto-invertido) !important;     /* texto contrario */
    text-transform: uppercase;            /* opcional */
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .btn-whatsapp:hover,
  .btn-whatsapp:focus {
    background-color: var(--sn-texto-2) !important;
    border-color: var(--sn-texto-2) !important;
  }
  .btn-whatsapp svg {
    fill: var(--sn-texto-invertido) !important;      /* icono contrario */
  }

  /* Responsividad */
  @media (max-width: 576px) {
    .modal-dialog {
      margin: 1rem;
    }
    .modal-content {
      font-size: 0.9rem;
    }
  }

/* ── Botones de origen (Foto / Galería / PDF) ── */
.deposit-btn-group {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}

.deposit-source-btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  padding: 0.6rem 0.4rem;
  background: var(--sn-marca-suave);
  border: 2px solid var(--sn-marca);
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.78rem;
  color: var(--sn-marca-texto);
  font-weight: 500;
  text-align: center;
  transition: background 0.15s, transform 0.1s;
  -webkit-appearance: none;
}

.deposit-source-btn:active {
  background: var(--sn-superficie-3);
  transform: scale(0.96);
}

.deposit-source-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.deposit-source-icon {
  font-size: 1.8rem;
  line-height: 1;
}

/* ── Preview compacto ── */
.deposit-preview-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--sn-superficie-2);
  border: 1px solid var(--sn-borde);
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
}

.deposit-preview-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid var(--sn-borde);
  flex-shrink: 0;
}

.deposit-preview-label {
  font-size: 0.8rem;
  color: var(--sn-texto-2);
}

/* ── Badge PDF ── */
.deposit-pdf-badge {
  background: var(--sn-alerta-suave);
  border: 1px solid var(--sn-alerta);
  border-radius: 8px;
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  color: var(--sn-alerta-texto);
}
`, "",{"version":3,"sources":["webpack://./src/components/DepositModal.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,2BAA2B;AAC3B;IACI,+CAA+C;EACjD;;EAEA,yBAAyB;EACzB;IACE,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,wCAAwC;IACxC,wCAAwC;EAC1C;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,SAAS;EACT;IACE,eAAe;IACf,sCAAsC;EACxC;;EAEA,4BAA4B;EAC5B;IACE,qBAAqB;EACvB;EACA;;IAEE,sBAAsB;EACxB;;EAEA,YAAY;EACZ;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,uCAAuC;IACvC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,yCAAyC;IACzC,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA,gCAAgC;EAChC;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;;EAEA,0BAA0B;EAC1B;IACE,WAAW;IACX,YAAY;EACd;;EAEA,4BAA4B;EAC5B;;IAEE,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA,WAAW;EACX;IACE,wCAAwC;IACxC,qCAAqC;EACvC;;EAEA,+CAA+C;EAC/C;IACE,4CAA4C,KAAK,kBAAkB;IACnE,wCAAwC;IACxC,2CAA2C,MAAM,oBAAoB;IACrE,yBAAyB,aAAa,aAAa;IACnD,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;EACb;EACA;;IAEE,8CAA8C;IAC9C,0CAA0C;EAC5C;EACA;IACE,0CAA0C,OAAO,oBAAoB;EACvE;;EAEA,kBAAkB;EAClB;IACE;MACE,YAAY;IACd;IACA;MACE,iBAAiB;IACnB;EACF;;AAEF,mDAAmD;AACnD;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B","sourcesContent":["/* DepositModal.css */\n\n/* Fondo semitransparente */\n.modal-backdrop {\n    background-color: rgba(0, 0, 0, 0.6) !important;\n  }\n\n  /* Contenedor del modal */\n  .modal-content {\n    border-radius: 0.5rem;\n    box-shadow: var(--sn-sombra);\n    overflow: hidden;\n  }\n\n  /* Header */\n  .modal-header {\n    background-color: var(--sn-superficie-2);\n    border-bottom: 1px solid var(--sn-borde);\n  }\n  .modal-header .modal-title {\n    font-weight: 600;\n    color: var(--sn-texto);\n  }\n\n  /* Body */\n  .modal-body {\n    padding: 1.5rem;\n    background-color: var(--sn-superficie);\n  }\n\n  /* Tablas dentro del modal */\n  .modal-body .table {\n    margin-bottom: 1.5rem;\n  }\n  .modal-body .table th,\n  .modal-body .table td {\n    vertical-align: middle;\n  }\n\n  /* Alertas */\n  .alert {\n    border-radius: 0.375rem;\n    font-size: 0.95rem;\n  }\n  .alert-success {\n    background-color: var(--sn-exito-suave);\n    border-color: var(--sn-exito);\n    color: var(--sn-exito-texto);\n  }\n  .alert-danger {\n    background-color: var(--sn-peligro-suave);\n    border-color: var(--sn-peligro);\n    color: var(--sn-peligro-texto);\n  }\n\n  /* Inputs y botones superiores */\n  .modal-body input[type=\"file\"] {\n    padding: 0.375rem 0.75rem;\n  }\n  .modal-body .btn {\n    font-size: 0.9rem;\n  }\n\n  /* Spinner centrar texto */\n  .spinner-border {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  /* Imágenes PDF y previews */\n  .modal-body embed,\n  .modal-body img {\n    border: 1px solid var(--sn-borde);\n    border-radius: 0.25rem;\n  }\n\n  /* Footer */\n  .modal-footer {\n    background-color: var(--sn-superficie-2);\n    border-top: 1px solid var(--sn-borde);\n  }\n\n  /* Botón de WhatsApp personalizado en grafito */\n  .btn-whatsapp {\n    background-color: var(--sn-texto) !important;    /* fondo grafito */\n    border-color: var(--sn-texto) !important;\n    color: var(--sn-texto-invertido) !important;     /* texto contrario */\n    text-transform: uppercase;            /* opcional */\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  .btn-whatsapp:hover,\n  .btn-whatsapp:focus {\n    background-color: var(--sn-texto-2) !important;\n    border-color: var(--sn-texto-2) !important;\n  }\n  .btn-whatsapp svg {\n    fill: var(--sn-texto-invertido) !important;      /* icono contrario */\n  }\n\n  /* Responsividad */\n  @media (max-width: 576px) {\n    .modal-dialog {\n      margin: 1rem;\n    }\n    .modal-content {\n      font-size: 0.9rem;\n    }\n  }\n\n/* ── Botones de origen (Foto / Galería / PDF) ── */\n.deposit-btn-group {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n}\n\n.deposit-source-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.6rem 0.4rem;\n  background: var(--sn-marca-suave);\n  border: 2px solid var(--sn-marca);\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 0.78rem;\n  color: var(--sn-marca-texto);\n  font-weight: 500;\n  text-align: center;\n  transition: background 0.15s, transform 0.1s;\n  -webkit-appearance: none;\n}\n\n.deposit-source-btn:active {\n  background: var(--sn-superficie-3);\n  transform: scale(0.96);\n}\n\n.deposit-source-btn.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.deposit-source-icon {\n  font-size: 1.8rem;\n  line-height: 1;\n}\n\n/* ── Preview compacto ── */\n.deposit-preview-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: var(--sn-superficie-2);\n  border: 1px solid var(--sn-borde);\n  border-radius: 8px;\n  padding: 0.5rem 0.75rem;\n}\n\n.deposit-preview-img {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid var(--sn-borde);\n  flex-shrink: 0;\n}\n\n.deposit-preview-label {\n  font-size: 0.8rem;\n  color: var(--sn-texto-2);\n}\n\n/* ── Badge PDF ── */\n.deposit-pdf-badge {\n  background: var(--sn-alerta-suave);\n  border: 1px solid var(--sn-alerta);\n  border-radius: 8px;\n  padding: 0.4rem 0.75rem;\n  font-size: 0.85rem;\n  color: var(--sn-alerta-texto);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
